import i18n from 'i18next'; import React from 'react';
import {
  LinearProgress,
  makeStyles,
  Typography } from
  '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  progress: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2)
    },
    height: '100px',
    padding: '100px'
  }
}));

const ProgressBar = () => {
  const classes = useStyles();

  return (
    <div className={classes.progress}>
      <Typography variant="span">
        {i18n.t('ProgressBar.y\xFCkleniyor')}

      </Typography>
      <LinearProgress title={i18n.t('ProgressBar.y\xFCkleniyor')} />
    </div>
  );
};

export default ProgressBar;
